// Bus de notificaciones — funciona desde cualquier lado (services, hooks, handlers)
// sin necesidad de context ni prop drilling.
let listeners = [];
let seq = 0;

function emit(type, message, opts = {}) {
  if (!message) return;
  const item = {
    id: ++seq,
    type,
    message: String(message),
    duration: opts.duration ?? (type === "error" ? 6000 : 3000),
  };
  listeners.forEach((l) => l(item));
  return item.id;
}

export const toast = {
  error: (m, o) => emit("error", m, o),
  success: (m, o) => emit("success", m, o),
  info: (m, o) => emit("info", m, o),
  subscribe(fn) {
    listeners.push(fn);
    return () => { listeners = listeners.filter((l) => l !== fn); };
  },
};
